(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mfunsPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["mfunsPlayer"] = factory();
	else
		root["mfunsPlayer"] = factory();
})(self, function() {
return 